"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gitalkComponent = _interopRequireDefault(require("@suziwen/gitalk/dist/gitalk-component"));

var _jsxFileName = "/home/suziwen/jobdisk/git/gatsby-plugin-gitalk/src/components/Gitalk.jsx";

function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var GGitalk = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2.default)(GGitalk, _React$Component);

  var _super = _createSuper(GGitalk);

  function GGitalk(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.pluginConfig = typeof GATSBY_GITALK_CONFIG !== "undefined" && GATSBY_GITALK_CONFIG !== '' ? GATSBY_GITALK_CONFIG : '';
    return _this;
  }

  var _proto = GGitalk.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        options = _this$props.options,
        props = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["options"]);
    var gitalkConfig = (0, _extends2.default)({}, this.pluginConfig, {}, options);

    if (typeof window !== 'undefined') {
      return /*#__PURE__*/_react.default.createElement(_gitalkComponent.default, (0, _extends2.default)({}, props, {
        options: gitalkConfig,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 16,
          columnNumber: 9
        }
      }));
    } else {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }
  };

  return GGitalk;
}(_react.default.Component);

exports.default = GGitalk;